<template>
  <div class="main-content"
       v-title
       data-title="商品详情_试剂采购库存管理系统">

    <div class="goods-info">
      <div class="order-info">
        <span class="code">订单编号：2021037268368270</span>
        <span>总金额：<i>¥5999.00</i></span>
      </div>
      <el-table :data="tableData"
                :header-cell-style="{background:'#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight:700,height:'54px'
                }"
                border
                style="width: 100%">
        <el-table-column prop="date"
                         label="供应商">
        </el-table-column>
        <el-table-column prop="name"
                         label="商品编码">
        </el-table-column>
        <el-table-column prop="province"
                         label="商品名称">
        </el-table-column>
        <el-table-column prop="city"
                         label="CAS号">
        </el-table-column>
        <el-table-column prop="address"
                         label="结构式">
        </el-table-column>
        <el-table-column prop="address"
                         label="售价">
        </el-table-column>
        <el-table-column prop="address"
                         label="库存">
        </el-table-column>
        <el-table-column prop="zip"
                         label="重量（单位）">
        </el-table-column>
        <el-table-column prop="zip"
                         label="购买量">
        </el-table-column>
        <el-table-column prop="zip"
                         label="金额">
        </el-table-column>
      </el-table>
      <div class="last">
        <p>规格名称：参数1；规格名称：参数2；规格名称：参数2；</p>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 1,
      radio: '1',
      dialogBind: false,
      content: '',
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1517 弄',
          zip: 200333,
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1519 弄',
          zip: 200333,
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
        },
      ],
      howWidth: 12,
    }
  },
  created() {
    this.initData()
  },
  methods: {
    //绑定柜机
    bindCabinet(row) {
      this.dialogBind = true
      console.log(row)
    },
    //去下单
    toOverBook() {
      this.$router.push({ path: 'overBook' })
    },
    initData() {
      this.$apiFetch
        .get('/tinyConfig/contact')
        .then((data) => {
          console.log('数据', data)
          this.content = data.data.richTextValue
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}
.order-info {
  border-bottom: 1px solid #eef2f8;
  background-color: #ffffff;
  padding-bottom: 20px;
  span {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    line-height: 24px;
    i {
      color: #fa8c16;
    }
  }
  span.code {
    padding-right: 60px;
  }
}
/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;
}
.goods-info {
  padding: 20px;
  background-color: #ffffff;
}
.last {
  border: 1px solid #e8e8e8;
  border-top: unset;
  height: 53px;
  border-radius: 0 0 4px 4px;
  p {
    color: rgba(0, 0, 0, 0.65);
    line-height: 54px;
    font-size: 12px;
    padding-left: 16px;
  }
}
</style>

